export const VALENTINES_UPSELL_PARAM = 'valentinesUpsell';
